/**
 * The Loading component, used while resources load
 * Keep this component as similar as possible to the resource page importing it
 */
import React from "react";
import PropTypes from "prop-types";
import { Container, Progress } from 'reactstrap';

/**
 * Dummy content to mock the general structure of the pages while content loads
 */
const LoadingContent = (props, context) => {
  
  return (
    <div className='loadingcontent'> 
      <Progress animated bar color="primary" value="100" className='loadingcontent__progressbar' />
      { props.showText &&
        <Container>
          <div className='loadingcontent__content'>
            <h1 className='mt-5'>{context.t("LoadingContent.message")}</h1>
          </div>
        </Container>
      }       
    </div>
  );
}
/**  define proptype for the 'translation' function  */
LoadingContent.contextTypes = {
  t: PropTypes.func
}
export default LoadingContent;
